import React from 'react';

export default function EyeIcon() {
  return (
    <svg
      className="icon icon-eye"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="13"
      viewBox="0 0 24 13"
    >
      <path
        fill="#898492"
        d="M20.7 3.42a12.88 12.88 0 0 0-17.48 0L0 6.46l3.3 3.12A12.68 12.68 0 0 0 12.04 13c3.17 0 6.33-1.14 8.74-3.42L24 6.54zm-.49 5.62a12.04 12.04 0 0 1-16.34 0L1.15 6.46l2.64-2.5a12.04 12.04 0 0 1 16.34 0l2.72 2.58z"
      />
      <path
        fill="#898492"
        d="M12.5 2a4.5 4.5 0 1 0 .01 9.01A4.5 4.5 0 0 0 12.5 2zm0 8a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z"
      />
    </svg>
  );
}
